import { createPortal } from "react-dom";
import { useState, useEffect } from "react";
import { AlertTriangle, X } from "lucide-react";

import CustomButton from "@/components/desktop/button/CustomButton";
import CustomProcessingContent from "@/components/desktop/modal/CustomProcessingContent";

import styles from "./custom-confirm-modal.module.scss";

const CustomConfirmModal = ({
	open,
	onClose,
	onConfirm,
	title,
	message,
	confirmText = "Sí, continuar",
	cancelText = "No, cancelar",
	isLoading = false,
	processingTitle = "Procesando solicitud",
	processingMessage = "",
	processingDescription,
	verificationText,
}) => {
	const [verificationInput, setVerificationInput] = useState("");

	useEffect(() => {
		if (open) {
			setVerificationInput("");
		}
	}, [open]);

	if (!open) return null;

	const isConfirmDisabled = verificationText ? verificationInput.trim() !== verificationText : false;

	const shouldShowProcessingContent = isLoading && Boolean(processingMessage);

	const handleConfirm = () => {
		if (!isLoading && !isConfirmDisabled) {
			onConfirm();
		}
	};

	const handleCancel = () => {
		if (!isLoading) {
			onClose();
		}
	};

	return createPortal(
		<div className={styles.overlay}>
			<div className={styles.modal}>
				<div className={styles.header}>
					{!shouldShowProcessingContent && (
						<div className={styles.iconWrapper}>
							<AlertTriangle className={styles.icon} />
						</div>
					)}
					<h2 className={styles.title}>{shouldShowProcessingContent ? processingTitle : title}</h2>
					{!isLoading && (
						<button className={styles.closeButton} onClick={handleCancel} aria-label="Cerrar">
							<X size={20} />
						</button>
					)}
				</div>

				<div className={styles.content}>
					{shouldShowProcessingContent ? (
						<CustomProcessingContent message={processingMessage} description={processingDescription} />
					) : (
						<>
							<div className={styles.message}>{message}</div>
							{verificationText && (
								<div className={styles.verificationWrapper}>
									<label className={styles.verificationLabel}>
										Escribe <strong>{verificationText}</strong> para confirmar:
									</label>
									<input
										className={styles.verificationInput}
										type="text"
										value={verificationInput}
										onChange={(e) => setVerificationInput(e.target.value)}
										autoComplete="off"
									/>
								</div>
							)}
						</>
					)}
				</div>

				{!shouldShowProcessingContent && (
					<div className={styles.footer}>
						<CustomButton variant="secondary" onClick={handleCancel} disabled={isLoading}>
							{cancelText}
						</CustomButton>
						<CustomButton variant="primary" onClick={handleConfirm} loading={isLoading} disabled={isConfirmDisabled}>
							{confirmText}
						</CustomButton>
					</div>
				)}
			</div>
		</div>,
		document.body,
	);
};

export default CustomConfirmModal;
